import { useCallback, useEffect } from 'react';
import { useNextMicro, useUpdate } from '@bydesign-ui/hooks';
import { usePoint } from './usePoint';
export function useUpStep(part, type) {
  var detectUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var update = useNextMicro(useUpdate());
  var point = usePoint(part);
  var value = point.getPrecisionValue(type);

  var _point$getAxis$getAxi = point.getAxis(type).getAxisConfig(),
      step = _point$getAxis$getAxi.step,
      max = _point$getAxis$getAxi.max;

  useEffect(function () {
    detectUpdate && point.addListener('repaint', update);
    return function () {
      return point.removeListener('repaint', update);
    };
  }, [point]);
  var handler = useCallback(function (stepCount) {
    point.upStep(type, stepCount);
  }, [point]);
  return [+value + step > max, handler];
}